import React, { forwardRef, useCallback, useEffect } from 'react';
import useMotionControls from '@polestar/component-warehouse-react/components/motion/useMotionControls';
import InView from '@polestar/component-warehouse-react/components/in-view/InView';
import { motion } from 'framer-motion';
import { genericMotionVariants } from '@polestar/component-warehouse-react/components/motion/helpers';
const MotionGroup = forwardRef(({ inView, controls: _controls, children, ...props }, ref) => {
    let content = children;
    const { controls } = useMotionControls();
    const internalControls = _controls || controls;
    useEffect(() => {
        if (!inView && !_controls) {
            internalControls.show();
        }
    }, [_controls, controls, inView, internalControls]);
    const handleEnter = useCallback(() => {
        var _a, _b;
        internalControls.show();
        if (typeof inView === 'object' && 'onView' in inView && 'onEnter' in inView) {
            (_b = (_a = inView).onEnter) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
    }, [internalControls, inView]);
    if (inView) {
        const inViewProps = typeof inView === 'boolean'
            ? {
                threshold: 0.5,
            }
            : inView;
        content = (React.createElement(InView, { alwaysRenderChildren: true, triggerOnce: true, ...inViewProps, onEnter: handleEnter }, content));
    }
    return (React.createElement(motion.div, { ref: ref, variants: genericMotionVariants, initial: internalControls.get(), animate: internalControls, ...props }, content));
});
MotionGroup.displayName = 'MotionGroup';
export default MotionGroup;
